import React, {
    ReactElement,
} from "react";
import { Form } from "react-bootstrap";
import { BiTrash } from "react-icons/bi";
import ExpandingSection from "../../../../components/expanding-section/ExpandingSection";
import WorkflowServiceApiSelector from "./ApiSelector";
import { createId, Json } from "./base";
import InputList from "./Input";
import Template, { MapParameters } from "./Template";

export default function WorkflowServiceToken({ json, onChange, rootJson }: {
    json: Json;
    onChange: (current: ((json: Json) => Json)) => void;
    rootJson: Json
}): ReactElement {
    const connection = json.connection as Json;
    const changeConnection = (child: Json) => {
        onChange(current => ({
            ...current,
            connection: {
                ...connection,
                ...child,
            },
        }));
    };
    const deleteKey = (key: string) => {
        onChange(current => {
            const copy = { ...current };
            delete (copy.connection as Record<string, string>)[key];
            return copy;
        });
    };

    if (connection?.token) {
        const token = connection?.token as Json | undefined;
        const changeToken = (child: Json) => {
            changeConnection({
                token: {
                    ...token,
                    ...child,
                },
            });
        };
        return (
            <div>
                <div
                    className="d-flex justify-content-between align-items-start"
                >
                    <h5>Token</h5>
                    <button
                        type="button"
                        className="btn btn-none btn-sm p-0 text-light  "
                        onClick={() => deleteKey("token")}
                    >
                        <BiTrash />
                    </button>

                </div>

                <ExpandingSection title="Token based">
                    <Form.Group className="mb-5">
                        <Form.Label className="fw-bolder">API</Form.Label>
                        <WorkflowServiceApiSelector
                            rootJson={rootJson}
                            json={json?.api as Json}
                            onChange={value => changeToken({
                                ...token,
                                api: value,
                            })}
                        />
                        <Form.Text>
                            The API
                        </Form.Text>
                    </Form.Group>

                </ExpandingSection>

                <ExpandingSection title="Connection">

                    <Form.Group className="mb-5">
                        <Form.Label className="fw-bolder">Url</Form.Label>
                        <Template
                            json={(token?.connection as Json)?.url as Json}
                            onChange={value => changeToken({
                                connection: {
                                    ...(token?.connection as Json),
                                    url: value,
                                },
                            })}

                        />
                        <Form.Text className="d-block">
                            This helps set up a default url that applies to all downstream requests.
                        </Form.Text>
                    </Form.Group>

                    <MapParameters
                        title="Headers"
                        json={(token?.connection as Json)?.headers as Json}
                        onChange={value => {
                            changeToken({
                                connection: {
                                    ...(token?.connection as Json),
                                    headers: value,
                                },
                            });
                        }}
                    />
                </ExpandingSection>

            </div>
        );
    }

    return (
        <button
            type="button"
            className="btn btn-primary py-1 px-2"
            onClick={() => changeConnection({
                id: `urn:fq:workflow-service-connection:(urn:fq:workflow-service:${json.id},${createId()})`,
                ...connection,
                token: {
                },
            })}
        >
            Token
        </button>
    );
}
